(function () {
    var root = document.querySelector('[data-plara-shipping]');
    if (!root) return;

    var countdownNode = root.querySelector('[data-shipping-countdown]');
    if (!countdownNode) return;

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function getNextCutoff() {
      var now = new Date();
      var cutoff = new Date();
      cutoff.setHours(16, 0, 0, 0);

      if (now >= cutoff) {
        cutoff.setDate(cutoff.getDate() + 1);
      }

      return cutoff;
    }

    function updateCountdown() {
      var now = new Date();
      var cutoff = getNextCutoff();
      var diff = cutoff.getTime() - now.getTime();

      if (diff < 0) diff = 0;

      var hours = Math.floor(diff / 1000 / 60 / 60);
      var minutes = Math.floor((diff / 1000 / 60) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      countdownNode.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  })();